// A promise that can be resolved or rejected externally
export class DeferredPromise<T> implements PromiseLike<T> {

    private promise: Promise<T>;

    constructor() {
        this.promise = new Promise<T>((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    resolve!: (value: T | PromiseLike<T>) => void;

    reject!: (reason?: any) => void;

    then<R1 = T, R2 = never>(onFulfilled?: ((value: T) => R1 | PromiseLike<R1>) | undefined | null, onRejected?: ((reason: any) => R2 | PromiseLike<R2>) | undefined | null): Promise<R1 | R2> {
        return this.promise.then(onFulfilled, onRejected);
    }

    catch<R = never>(onRejected?: ((reason: any) => R | PromiseLike<R>) | undefined | null): Promise<T | R> {
        return this.promise.catch(onRejected);
    }
}
